import { nanoid } from 'nanoid';
import React from 'react';

export interface TextProps {
  node: {
    fieldList?: string[];
    isOrdered?: boolean;
  };
}

export const ListParagraph = ({ node }: TextProps) => {
  return node.isOrdered ? (
    <ol>
      {node.fieldList?.map((value) => (
        <li key={nanoid()}>
          <div dangerouslySetInnerHTML={{ __html: value || '' }} />
        </li>
      ))}
    </ol>
  ) : (
    <ul>
      {node.fieldList?.map((value) => (
        <li key={nanoid()}>
          <div dangerouslySetInnerHTML={{ __html: value || '' }} />
        </li>
      ))}
    </ul>
  );
};
